module.exports = __webpack_public_path__ + "static/media/minimize.f3e1610b.svg";